import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UpcomingExam.css';
import API_URL from '../../api/ExamCalendarApi';

const UpcomingExams = () => {
    const [exams, setExams] = useState([]);
    const [examName, setExamName] = useState('');
    const [examDate, setExamDate] = useState('');
    const [examLink, setExamLink] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [currentExamId, setCurrentExamId] = useState(null);

    // Fetch exams when the component mounts
    useEffect(() => {
        fetchExams();
    }, []);

    // Fetch all upcoming exams
    const fetchExams = async () => {
        try {
            const response = await axios.get(`${API_URL}/homepage/upcoming-exams`);
            setExams(response.data.exams);
        } catch (error) {
            console.error('Error fetching exams:', error);
        }
    };

    // Handle form submission for create or update
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!examName || !examDate) {
            setError('Exam name and date are required');
            return;
        }

        const examData = { examName, examDate, examLink };

        try {
            if (updateMode) {
                await axios.put(`${API_URL}/homepage/update-upcoming-exam/${currentExamId}`, examData);
                setSuccessMessage('Exam updated successfully');
            } else {
                await axios.post(`${API_URL}/homepage/add-upcoming-exam`, examData);
                setSuccessMessage('Exam added successfully');
            }

            // Reset form and update the exams list
            setExamName('');
            setExamDate('');
            setExamLink('');
            setUpdateMode(false);
            fetchExams();
        } catch (error) {
            setError('Error saving exam');
            setSuccessMessage('');
        }
    };

    // Handle deleting an exam
    const handleDelete = async (examId) => {
        try {
            await axios.delete(`${API_URL}/homepage/delete-upcoming-exam/${examId}`);
            setSuccessMessage('Exam deleted successfully');
            fetchExams();
        } catch (error) {
            setError('Error deleting exam');
        }
    };

    // Handle editing an exam (populate form with current values)
    const handleEdit = (exam) => {
        setExamName(exam.examName);
        setExamDate(exam.examDate);
        setExamLink(exam.examLink);
        setCurrentExamId(exam._id);
        setUpdateMode(true);
    };

    return (
        <div className="admin-upcomingexam-container">
            <h2 className="admin-upcomingexam-header">Manage Upcoming Exams</h2>

            {error && <div className="admin-upcomingexam-alert admin-upcomingexam-alert-danger">{error}</div>}
            {successMessage && <div className="admin-upcomingexam-alert admin-upcomingexam-alert-success">{successMessage}</div>}

            <form className="admin-upcomingexam-form" onSubmit={handleSubmit}>
                <div className="admin-upcomingexam-form-group">
                    <label htmlFor="examName" className="admin-upcomingexam-label">Exam Name</label>
                    <input
                        type="text"
                        id="examName"
                        className="admin-upcomingexam-input"
                        value={examName}
                        onChange={(e) => setExamName(e.target.value)}
                        placeholder="Enter exam name"
                    />
                </div>

                <div className="admin-upcomingexam-form-group">
                    <label htmlFor="examDate" className="admin-upcomingexam-label">Exam Date</label>
                    <input
                        type="date"
                        id="examDate"
                        className="admin-upcomingexam-input"
                        value={examDate}
                        onChange={(e) => setExamDate(e.target.value)}
                    />
                </div>

                <div className="admin-upcomingexam-form-group">
                    <label htmlFor="examLink" className="admin-upcomingexam-label">Exam Link (optional)</label>
                    <input
                        type="url"
                        id="examLink"
                        className="admin-upcomingexam-input"
                        value={examLink}
                        onChange={(e) => setExamLink(e.target.value)}
                        placeholder="Enter exam link"
                    />
                </div>

                <button type="submit" className="admin-upcomingexam-button">
                    {updateMode ? 'Update Exam' : 'Add Exam'}
                </button>
            </form>

            <h3 className="admin-upcomingexam-header">Upcoming Exams</h3>
            <div className="admin-upcomingexam-table-wrapper">
            <table className="admin-upcomingexam-table">
                <thead>
                    <tr>
                        <th className="admin-upcomingexam-th">Exam Name</th>
                        <th className="admin-upcomingexam-th">Exam Date</th>
                        <th className="admin-upcomingexam-th">Exam Link</th>
                        <th className="admin-upcomingexam-th">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {exams.map((exam) => (
                        <tr key={exam._id} className="admin-upcomingexam-tr">
                            <td className="admin-upcomingexam-td">{exam.examName}</td>
                            <td className="admin-upcomingexam-td">{exam.examDate}</td>
                            <td className="admin-upcomingexam-td">
                                {exam.examLink ? (
                                    <a href={exam.examLink} target="_blank" rel="noopener noreferrer" className="admin-upcomingexam-link">Link</a>
                                ) : (
                                    '-'
                                )}
                            </td>
                            <td className="admin-upcomingexam-td">
                                <button className="admin-upcomingexam-action-button admin-upcomingexam-edit-button" onClick={() => handleEdit(exam)}>
                                    Edit
                                </button>
                                <button className="admin-upcomingexam-action-button admin-upcomingexam-delete-button" onClick={() => handleDelete(exam._id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default UpcomingExams;